import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { UserState } from './user.state';
import { ProfilePicture } from '../../models/user/profile-picture.model';
import { Observable } from 'rxjs';
import { GetUser, LoadProfilePicture, SaveUser } from './user.actions';
import { User } from 'src/app/models/user';

@Injectable({
  providedIn: 'root'
})
export class UserFacade {
  private readonly store = inject(Store);

  @Select(UserState.profilePicture) profilePicture$: Observable<ProfilePicture | undefined>;
  @Select(UserState.user) user$: Observable<User | undefined>;

  get user() {
    return this.store.selectSnapshot(UserState.user);
  }

  loadProfilePicture(userId: string) {
    this.store.dispatch(new LoadProfilePicture(userId));
  }

  getUser(userId: string): Observable<User> {
    return this.store.dispatch(new GetUser(userId));
  }

  setUser(user: User) {
    return this.store.dispatch(new SaveUser(user));
  }
}
